<template>
  <div>
    <div
      class="clearfix"
      v-for="(button_group, index) in buttons"
      :key="button_group.name"
    >
      <b-button-group :class="button_group.style_classes">
        <b-button
          v-for="button in button_group.buttons"
          :key="button.name"
          :id="button.id"
          :variant="button.variant"
          :type="button.type"
          @click="button_click(button.name)"
          ><b-icon v-if="button.icon" :icon="button.icon" class="mr-2"></b-icon
          >{{ button.label }}
          <b-spinner
            v-if="button.spinner"
            :id="button.spinner_id"
            small
            style="display: none; margin-right: 0.75rem !important"
            class="float-left m-1"
          ></b-spinner
        ></b-button>
      </b-button-group>
      <div class="clearfix"></div>
      <hr v-if="index != buttons.length - 1" class="clearfix col-xs-12" />
    </div>
  </div>
</template>

<script>
export default {
  name: "FormButtons",
  methods: {
    button_click: function(button_name) {
      this.$emit("button_click", button_name);
    }
  },
  props: {
    buttons: Array
  }
};
</script>
